export default __webpack_public_path__ + "static/media/defensive.5b3ea36e.png";